import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import toast, { Toaster } from 'react-hot-toast';


const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
      const myPromise = emailjs.sendForm('service_hd0xy2k', 'template_jskk7rx', form.current, 'fBSswtRW8TblDpc0E').then((result)=>{form.current.reset();});

      toast.promise(myPromise, {
        loading: 'Loading',
        success: 'Email send successfully',
        error: 'Error when fetching',
      });
      // emailjs.sendForm('service_hd0xy2k', 'template_jskk7rx', form.current, 'fBSswtRW8TblDpc0E')
      //   .then((result) => {
      //     toast.success('Successfully send!')
      //       console.log(result.text);
      //   }, (error) => {
      //       console.log(error.text);
      //   });
    };
  return (
    <>
      <section className="contact section" id="contact">
        <h2 className="section__title">Contact Me</h2>
        <span className="section__subtitle">Get in touch</span>
        <div className="contact__container container grid">
          <div>
            <div className="contact__information">
              <i className="uil uil-instagram contact__icon"></i>
              <div>
                <h3 className="contact__title">Follow Me</h3>
                <a
                  href="https://www.instagram.com/irenuka__/?hl=en"
                  rel="noreferrer"
                  target={"_blank"}
                  className="contact__subtitle"
                >
                  Renuka Rathva
                </a>
                {/* <span className="contact__subtitle">999-777-666</span> */}
              </div>
            </div>
            <div className="contact__information">
              <i className="uil uil-envelope contact__icon"></i>
              <div>
                <h3 className="contact__title">Email</h3>
                <span className="contact__subtitle">
                  renukarathva3@gmail.com
                </span>
              </div>
            </div>
            {/* <div className="contact__information">
              <i className="uil uil-map-marker contact__icon"></i>
              <div>
                <h3 className="contact__title">Location</h3>
                <span className="contact__subtitle">
                  Pune - Wagholi , 412356
                </span>
              </div>
            </div> */}
          </div>

          <form ref={form} onSubmit={sendEmail} className="contact__form grid">
            <div className="contact__inputs grid">


              <div className="contact__content">
                <label className="contact__label">Name</label>
                <input type="text" name="from_name" required className="contact__input"/>
              </div>

                <div className="contact__content">
                <label className="contact__label">Email</label>
                <input type="email" name="to_name" required className="contact__input"/>
              </div>
            </div>
            <div className="contact__content">
                <label className="contact__label">Message</label>
                <textarea name="message" required cols="0"
                rows="4"
                className="contact__input"/>
              </div>

           
           

              <button type="submit" className="button button--flex" value="Submit"> Send Message <i className="uil uil-message button__icon"></i></button>
            {/* <input type="submit" className="button button--flex" value="Send" /> */}
          </form>
        </div>
      </section>
      <Toaster  position="top-center" />
    </>
  );
}

export default Contact